import { createSelector } from 'reselect'

import modalTypes from 'helpers/enums/modalTypes'
import userTooltipsSelector from 'redux/selectors/tooltips/tooltips_selector'
import videoTrimmingSelector from 'redux/selectors/interactive_video_creation/video_trimming_selector'
import interactiveVideoStatusTypes from 'helpers/enums/interactiveVideoCreation/videoStatusTypes'

const interactiveVideoCreationSelector = state => state.interactiveVideoCreation

const formatModal = (modalName, params) => ({
	modalName,
	visible: true,
	params,
})

const interactiveVideoCreationModalSelector = createSelector(
	[
		interactiveVideoCreationSelector,
		userTooltipsSelector,
		videoTrimmingSelector,
	],
	(
		interactiveVideoCreationState,
		userTooltipsState,
		videoTrimmingData,
	) => {
		let modal = interactiveVideoCreationState.modals[0]

		if (!modal) {
			if (
				interactiveVideoCreationState.trimTool.hasTrimmed
				&& !!userTooltipsState.tooltips.tooltipInteractiveVideoEditorWillTrimActivities
			) {
				modal = formatModal(modalTypes.INTERACTIVE_VIDEO_EDITOR_TRIM_TOOLTIP)
			}
			if (videoTrimmingData.isTrimToolOpen &&
				videoTrimmingData.hasDifferentTrim &&
				interactiveVideoCreationState.status === interactiveVideoStatusTypes.SAVING
			) {
				modal = formatModal(modalTypes.INTERACTIVE_VIDEO_TRIM_CHANGE_NOT_SAVED)
			}
		}

		return modal
	}
)

export default interactiveVideoCreationModalSelector
